import _ from "lodash";
import { useMemo } from "react";
import queryString from "query-string";
import { useQueryCache } from "react-query";
import JsonApi from "../../utils/json_api";
import { useLocation } from "react-router";
import { MainAdvancedFilters } from "../../utils/variables";

export const usePermitsFilters = (viewsPreference: any, aggregations: any) => {
  const queryCache = useQueryCache();
  const location = useLocation();
  const filtersData = useMemo(() => JSON.parse(viewsPreference?.value || "[]"), [viewsPreference?.value]);
  const views = useMemo(() => {
    return filtersData.map((viewData: any) => ({
      key: viewData.id,
      value: viewData.id,
      text: viewData.attributes.name,
    }));
  }, [filtersData]);

  const options = useMemo(
    () => ({
      filters: {
        id: {
          hidden: true,
        },
        q: {
          label: "Matches",
          max: 1,
          collapse: (values: string[]) => values.join(" "),
        },
        q_fields: {
          label: "Active Columns",
          array: false,
        },
        status: {
          label: "Status",
          options: _.get(aggregations, "options.status", []),
          array: true,
        },
        types: {
          label: "Types",
          options: [],
          array: true,
        },
        application_id: {
          label: "Application ID",
          value: "",
        },
        permit_number: {
          label: "Permit Number",
          value: "",
        },
        applicant: {
          label: "Applicant",
          value: "",
        },
        has_balance: {
          label: "Payment Status",
          value: "false",
        },
        expired_at: {
          label: "Expired Date",
          value: {},
        },
        submitted_at: {
          label: "Submitted Date",
          value: {},
        },
        primary_identifier: {
          label: "Primary Identifier",
          value: "",
        },
        assignee_ids: {
          label: "Assigned To",
          value: "",
        },
        view: {
          label: "View",
          hidden: viewsPreference === undefined,
          keywords: ["show me", "show"],
          options: views || [],
          query: viewsPreference?.query,
          resolver: (context: any, value: any) => {
            const view = JsonApi.findById(filtersData, value) as any;
            return [undefined, view?.attributes?.filters];
          },
        },
      },
    }),
    [queryCache, viewsPreference?.value, aggregations.options],
  );

  const initialFilterState = useMemo(() => {
    const query = queryString.parse(location.search, { arrayFormat: "bracket", parseBooleans: true });
    const tempQuery: any = {
      ...query,
      has_balance: query?.has_balance !== undefined ? String(query?.has_balance) : undefined,
    };
    if (query?.has_balance === undefined) {
      delete tempQuery.has_balance;
    }
    const newState = _.reduce(
      tempQuery,
      (result: any, values: any, key: string) => {
        if (["search", "status", "assignee_ids", "q_fields", "types", "filtersExpression", "q"].includes(key)) {
          result[key] = tempQuery[key];
        }
        if (key.includes("custom_field") || MainAdvancedFilters.map((filter: any) => filter.typesId).includes(key)) {
          result[key] = tempQuery[key];
        }
        return result;
      },
      {},
    );
    return newState;
  }, []);
  return {
    ...options,
    initialFilterState: initialFilterState,
  };
};
export default usePermitsFilters;
